import React from 'react'
import Attachment from '../../Edit/Attachment'

const PRAttachment = (props) => {
  return (
    <Attachment isEdit={false}/>
  )
}

export default PRAttachment
